<template>
    <div class="dialog-screen">
        <div class="table-layout" v-show="showTable">
            <el-table :data="pageDeviceImpInfoList" ref="deviceImpInfoTable" border @selection-change="handleSelectionChange" :row-class-name="markSelectedRowClassName" height="700">
                <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                <el-table-column label="源件" width="60" align="center" fixed="left">
                    <el-table-column prop="rowNo" label="行号" width="60" align="center"></el-table-column>
                </el-table-column>
                <el-table-column prop="failed" label="执行状态" width="60" align="center" fixed="left" v-show="startFlag">
                    <template slot-scope="rows">
                        <div v-if="rows.row.failed != null">
                            <span v-if="rows.row.failed" style="color: red;font-size: 20px">×</span>
                            <span v-else style="color: green;font-size: 20px">√</span>
                        </div>
                        <span class="font-gray3" v-else>未执行</span>
                    </template>
                </el-table-column>
                <el-table-column prop="failDesc" label="失败描述" width="350" align="left" fixed="left" v-show="startFlag"></el-table-column>
                <el-table-column v-if="viewFieldFlag('title')" :label="getFieldTitle('title')">
                    <el-table-column prop="title" width="250">
                        <template slot-scope="rows">
                            <span>{{rows.row.title || ''}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('tmpNo')" :label="getFieldTitle('tmpNo')">
                    <el-table-column prop="tmpNo" width="250"></el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('innerCode')" :label="getFieldTitle('innerCode')">
                    <el-table-column prop="innerCode" width="160"></el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('devcGroupFullName')" :label="getFieldTitle('devcGroupFullName')">
                    <el-table-column prop="devcGroupFullName" width="150" :render-header="setDevcGroup">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.devcGroupFullName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.devcGroupFullName.errorMsg">
                                <span>{{rows.row.devcGroupFullName}}&nbsp;</span>
                            </div>
                            <div v-else>{{rows.row.devcGroupFullName}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('inspectFlag')" :label="getFieldTitle('inspectFlag')" align="center">
                    <el-table-column prop="inspectFlag" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.inspectFlag" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('setupFlag')" :label="getFieldTitle('setupFlag')" align="center">
                    <el-table-column prop="setupFlag" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.setupFlag" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('maintFlag')" :label="getFieldTitle('maintFlag')" align="center">
                    <el-table-column prop="maintFlag" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.maintFlag" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('patrolFlag')" :label="getFieldTitle('patrolFlag')" align="center">
                    <el-table-column prop="patrolFlag" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.patrolFlag" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('repairFlag')" :label="getFieldTitle('repairFlag')" align="center">
                    <el-table-column prop="repairFlag" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.repairFlag" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('grabIssueAllowed')" :label="getFieldTitle('grabIssueAllowed')" align="center">
                    <el-table-column prop="grabIssueAllowed" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.grabIssueAllowed" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>
        <div class="clearfix">
            <el-pagination background class="fl mt5" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                           layout="prev, pager, next, jumper, sizes, total"></el-pagination>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="doDeviceImpModelImport">导入</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="validateDeviceImpModel(true)">逐条检查</div>
        </div>
    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {openPageRouteUrl, getDefaultPageSizes} from '../../../src/app.conf'
    import {showMerchtDevcDefSelectDlg, openDevcDefDetailDlg} from '../devcDef/showDlg'
    import {openBrandListSelectDlg, showDevcCatSelectDlg, showDevcGroupCatSelectDlg, showDevcBrandSelectDlg, showDevcGroupSelectDlg} from '../categ/selectDlg'
    import {openComStaffComnSelectDlg} from '../orgStruct/selectDlg'
    import {getMerchantBizParam} from '../asset/assetMain'
    import {loadAssetDeprMethodList, loadAllotAcntMethodList} from '../retailer/asset-comn'
    import {showDevcClassifyTagListSelectDlg} from '../devcCust/selectDlg'

    import devcApi from '../../api/devc'
    import retailerApi from '../../api/retailer'
    import shopStockApi from '../../api/shopStock'
    import userApi from '../../api/user'
    import merchtComnApi from '../../api/merchtComn'
    import comnApi from '../../api/comn'

    import SwbCategTree from '../categ/CategTree';
    Vue.regist(SwbCategTree);
    import SwbDefServicerForSelect from '../servicer/DefServicerForSelect';
    Vue.regist(SwbDefServicerForSelect);
    import SwbBrandSelect from '../categ/BrandSelect';
    Vue.regist(SwbBrandSelect);
    import SwbShopDeviceImpSetDate from './ShopDeviceImpSetDate';
    Vue.regist(SwbShopDeviceImpSetDate);

    export default {
        name: 'swb-shop-asset-bizState-imp-check',
        desc: '机构设备导入检查',
        props: ['fileObj', 'rootWidth', 'rootHeight', 'theDlg'],
        data: function () {
            return {
                tableHeight: 0,
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: [15, 50, 100, 200],// 特殊页面处理
                pageDeviceImpInfoList: {},
                deviceImpDto: {
                    originalFileName: null,
                    deviceImpInfoList: [],
                },
                theLoading: null,
                multipleSelection: [],
                startFlag: false, // 标记是否已开始逐条执行
                nextIndex: 0,
                checkNextIndex: 0,
                devcCustFieldList: [],
                comnXportConf: {},
                fieldMap: {},
                custFileds: [],
                showTable: false,
            }
        },
        watch: {
            rootWidth(newVal, oldVal){
                //
            },
            rootHeight(newVal, oldVal){
                this.recalcTableHeight();
            }
        },
        created: function () {
            let self = this;
            this.recalcTableHeight();
            this.getDevcCustFieldList();
            this.getComnXportConfByUsage(this.fileObj.extra.tplUsage, function () {
                self.getMerchtImpTplDlInfo(self.fileObj.extra.tplUsage, function () {
                    self.showTable = true;
                });
            });
            //
            let theLoading = MsgBox.loading();
            this.deviceImpDto.retailerBizUnitId = this.fileObj.extra.retailerBizUnitId;
            this.deviceImpDto.originalFileName = this.fileObj.extra.originalFileName;
            let deviceImpInfoList = this.fileObj.extra.deviceImpInfoList;
            deviceImpInfoList.forEach(function (el) {
                el.validateInfo = {
                    innerCode: {validateOk: true},
                    title: {validateOk: true},
                    devcGroupFullName: {validateOk: true},
                };
            });
            this.deviceImpDto.deviceImpInfoList = deviceImpInfoList;
            //
            this.pageSize = this.pageSizes.first();
            self.checkData();
            self.setPageDeviceImpInfoList();
            // 导入后进行一次检查
            self.validateDeviceImpModel(true);
            theLoading.close();
        },
        methods: {
            viewFieldFlag(name, ignoreBase){
                let custFileds = this.custFileds;
                let custFlag = true;
                if (!Utils.isNoB(custFileds) && custFileds.length > 0) {
                    custFlag = this.custFileds.indexOf(name) > -1;
                }
                //
                let baseFlag = this.fieldMap[name] != null;
                if (Utils.isTrue(ignoreBase)) {
                    baseFlag = true;
                }
                return custFlag && baseFlag;
            },
            getFieldTitle(name, defTitle){
                return this.fieldMap[name] != null ? this.fieldMap[name].title : defTitle;
            },
            getMerchtImpTplDlInfo(tplUsage, callback){
                let self = this;
                let theLoading = MsgBox.loading();
                merchtComnApi.getMerchtImpTplDlInfo({tplUsage: tplUsage}, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let merchtImpTplDlInfo = result.data;
                        if (!Utils.isNoB(merchtImpTplDlInfo) && !Utils.isNoB(merchtImpTplDlInfo.tplConfig)) {
                            let custFiledMap = JSON.decode(merchtImpTplDlInfo.tplConfig);
                            self.custFileds = custFiledMap['导入列表'];
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                    callback();
                });
            },
            getComnXportConfByUsage(tplUsage, callback){
                let self = this;
                let theLoading = MsgBox.loading();
                comnApi.getComnXportConfByUsage({usage: tplUsage}, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let comnXportConf = result.data;
                        //
                        let sheetList = comnXportConf.sheetList;
                        sheetList.forEach(function (sheet) {
                            if (sheet.name == '导入列表') {
                                let fieldList = sheet.fieldList;
                                self.fieldMap = fieldList.toMap('name');
                            }
                        });
                        //
                        self.comnXportConf = comnXportConf;
                    } else {
                        MsgBox.warning(result.message);
                    }
                    callback();
                });
            },
            getDevcCustFieldList(){
                let self = this;
                let theLoading = MsgBox.loading();
                merchtComnApi.getDevcCustFieldList({}, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let devcCustFieldList = result.data;
                        self.devcCustFieldList = Utils.merge([], devcCustFieldList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            recalcTableHeight(){
                this.tableHeight = this.rootHeight - 60 - 42;
            },
            markSelectedRowClassName(row){
                return this.multipleSelection.find(function (tmpRow) {
                    return tmpRow.rowNo == row.rowNo;
                }) != null ? 'selected-row' : '';
            },
            commonChangeEvent(row, colName){
                this.checkData();
            },
            checkData () {
                let self = this;
                let rows = this.deviceImpDto.deviceImpInfoList.clone();
                let itemLength = rows.length;
                for (let i = 0; i < itemLength; i++) {
                    let deviceImpDto = rows[i];
                    deviceImpDto.validateInfo = {
                        innerCode: {validateOk: true},
                        title: {validateOk: true},
                        devcGroupFullName: {validateOk: true},
                    };
                    // 检查[设备描述全称]
                    if (!Utils.isNoB(deviceImpDto.title)) {
                        deviceImpDto.title = this.replaceSL(deviceImpDto.title, ' ');
                    }
                }
                //记录被选中的行
                let oldSelectedRowNos = this.multipleSelection.pluck('rowNo');
                //
                this.deviceImpDto.deviceImpInfoList = rows;
                this.setPageDeviceImpInfoList();
                //（必须）延迟恢复被选中的行
                setTimeout(function () {
                    self.deviceImpDto.deviceImpInfoList.forEach(function (row) {
                        if (oldSelectedRowNos.indexOf(row.rowNo) != -1) {
                            self.$refs.deviceImpInfoTable.toggleRowSelection(row);
                        }
                    });
                }, 1000);
            },
            setPageDeviceImpInfoList: function () {
                let totalRows = this.deviceImpDto.deviceImpInfoList;
                let start = (this.pageNumber - 1) * this.pageSize;
                let end = this.pageNumber * this.pageSize;
                let rows = totalRows.slice(start, end);
                this.pageDeviceImpInfoList = rows;
                this.totalCount = totalRows.length;
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.setPageDeviceImpInfoList();
            },
            // 设置维保分组
            setDevcGroup(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                let params = {
                                    filter: {
                                        level: 2
                                    },
                                    checkBox: false
                                };
                                showDevcGroupSelectDlg(params, function (devcGroup, theDlg) {
                                    theDlg.close();
                                    for (let i = 0; i < self.multipleSelection.length; i++) {
                                        let tmpRow = self.multipleSelection[i];
                                        tmpRow.devcGroupId = devcGroup.id;
                                        tmpRow.devcGroupId1 = devcGroup.parentId;
                                        tmpRow.devcGroupId2 = devcGroup.id;
                                        tmpRow.devcGroupName = devcGroup.name;
                                        tmpRow.devcGroupFullName = devcGroup.fullName;
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '设置'),
                ])
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 逐条检查
            validateDeviceImpModel: function (isFirst) {
                this.checkNextIndex = isFirst ? 0 : this.checkNextIndex;
                this.startFlag = true;
                let self = this;
                let deviceImpDto = this.deviceImpDto;
                //
                let srcDeviceImpInfoList = deviceImpDto.deviceImpInfoList;
                let srcListLength = srcDeviceImpInfoList.length;
                let checkNextIndex = this.checkNextIndex;
                let srcImpInfo = srcDeviceImpInfoList[checkNextIndex];
                let postData = Utils.merge({}, deviceImpDto);
                postData.deviceImpInfoList = [srcImpInfo];
                postData.includeSubComs = this.fileObj.extra.includeSubComs || false;
                //
                let theLoading = MsgBox.loading("【源件行号：" + srcImpInfo.rowNo + "】正在处理，请稍后...");
                devcApi.validateAssetBizStateImpModel(postData, function (result) {
                    theLoading.hide();
                    let callItem = result.data.deviceImpInfoList[0];
                    if (result.type == 'info') {
                        callItem.failed = false;
                        callItem.failDesc = null;
                    } else {
                        callItem.failed = true;
                        callItem.failDesc = result.message;
                    }
                    srcDeviceImpInfoList[checkNextIndex] = Utils.merge({}, callItem);
                    deviceImpDto.deviceImpInfoList = srcDeviceImpInfoList;
                    self.deviceImpDto = Utils.merge({}, deviceImpDto);
                    self.checkData();
                    //
                    let pageSize = self.pageSize;
                    let pageNumber = (checkNextIndex + 1) / pageSize;
                    let pageNumber2 = (checkNextIndex + 1) % pageSize;
                    if (pageNumber2 != 0) {
                        pageNumber = pageNumber + 1;
                    }
                    self.handlePageChange(pageNumber);
                    if (checkNextIndex < srcListLength - 1) {
                        self.checkNextIndex += 1;
                        self.validateDeviceImpModel(false);
                    } else {
                        self.handlePageChange(1);
                    }
                });
            },
            // 逐条检查导入
            doDeviceImpModelImport() {
                let self = this;
                let deviceImpDto = this.deviceImpDto;
                deviceImpDto.retailerShopId = this.fileObj.extra.retailerShopId;
                deviceImpDto.retailerBizUnitId = this.fileObj.extra.retailerBizUnitId;
                deviceImpDto.includeSubComs = this.fileObj.extra.includeSubComs;
                //
                let theLoading = MsgBox.loading("正在执行导入");
                devcApi.doAssetBizStateImpModelImport(deviceImpDto, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        if (result.data) {
                            self.$emit('other-close', result.data);
                        } else {
                            MsgBox.warning('请检查通过再导入');
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            replaceSL(str, char) {
                if (!Utils.isNoB(str)) {
                    str = Utils.replace(str, '\r\n', char);
                    str = Utils.replace(str, '\r', char);
                    str = Utils.replace(str, '\n', char);
                }
                return str;
            },
        }
    }
</script>

<style>
    .el-table .selected-row {
        background: #c9e5f5;
    }
</style>



// WEBPACK FOOTER //
// src/compo/retailer/AssetBizStateImpCheck.vue